import type { RouteObject } from 'react-router-dom';
import { SignInPage } from './pages/SignInPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ChangePasswordRequiredPage } from './pages/ChangePasswordRequiredPage';
import { HandoffPage } from './pages/HandoffPage';

/**
 * Rotas públicas do módulo de autenticação — renderizadas fora do
 * AppLayout/AuthGuard (o usuário ainda não está logado).
 */
export const authPublicRoutes: RouteObject[] = [
  { path: 'sign-in', element: <SignInPage /> },
  { path: 'forgot-password', element: <ForgotPasswordPage /> },
  // Troca obrigatória após 403 PASSWORD_CHANGE_REQUIRED (senha temporária).
  { path: 'change-password-required', element: <ChangePasswordRequiredPage /> },
  // Chegada do SSO handoff — pública de propósito: quem cai aqui ainda não tem
  // sessão neste domínio, é o token do fragmento que a cria.
  { path: 'handoff', element: <HandoffPage /> },
];
